import { Package, Utensils, FileText, Percent, BookOpen, Settings, Users, TrendingUp, Newspaper, LayoutGrid, Printer } from 'lucide-react';
import { Link, useLocation } from 'wouter';

interface NavigationTab {
  path: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

const navigationTabs: NavigationTab[] = [
  {
    path: '/admin',
    label: 'Retail Products',
    icon: Package
  },
  {
    path: '/admin/restaurant/products',
    label: 'Restaurant Products',
    icon: Utensils
  },
  {
    path: '/admin/restaurant/orders',
    label: 'Restaurant Orders',
    icon: FileText
  },
  {
    path: '/admin/restaurant/discount-codes',
    label: 'Discount Codes',
    icon: Percent
  },
  {
    path: '/admin/rebates',
    label: 'Rebates',
    icon: TrendingUp
  },
  {
    path: '/admin/guide',
    label: 'Guide',
    icon: BookOpen
  },
  {
    path: '/admin/settings',
    label: 'Settings',
    icon: Settings
  },
  {
    path: '/admin/flyers',
    label: 'Instore Flyer',
    icon: LayoutGrid
  },
  {
    path: '/admin/weekly-flyer',
    label: 'Weekly Flyer',
    icon: Printer
  }
];

export function AdminNavigation() {
  const [location] = useLocation();

  const isActiveTab = (tabPath: string) => {
    if (tabPath === '/admin') {
      return location === '/admin';
    }
    return location.startsWith(tabPath);
  };

  return (
    <div className="bg-white border-b sticky top-0 z-50 print:hidden">
      <div className="container mx-auto px-4">
        <nav className="flex overflow-x-auto space-x-2 md:space-x-6">
          {navigationTabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = isActiveTab(tab.path);
            
            return (
              <Link 
                key={tab.path} 
                href={tab.path}
                className={`py-4 px-2 border-b-2 font-medium flex items-center gap-1 md:gap-2 whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-emerald-500 text-emerald-600'
                    : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{tab.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}